import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';
import { getUser } from 'src/utils/Common';

const SessionUser = getUser();

export const getSurveyAnswers = createAsyncThunk('/getSurveyAnswers', async () => {
  const response = await axios.get(`/GetSurveyAnswers`);
  return response.data;
});

export const getSurveyQuestions = createAsyncThunk('/getSurveyQuestions', async () => {
    const response = await axios.get(`/GetSurveyQuestions`);
    return response.data;
  });

export const getSurveyHeaders = createAsyncThunk('/getSurveyHeaders', async () => {
    const response = await axios.get(`/GetSurveyHeaders`);
    return response.data;
  });

export const getSurveyAnswerDetails = createAsyncThunk(
  '/getSurveyAnswerDetails',
  async (id) => {
    const response = await axios.get(`/GetSurveyAnswerDetails/${id}`);
    return response.data;
  }
);

export const getSurveyQuestionDetails = createAsyncThunk(
  '/getSurveyQuestionDetails',
  async (id) => {
    const response = await axios.get(`/GetSurveyQuestionDetails/${id}`);
    return response.data;
  }
);

export const getSurveyHeaderDetails = createAsyncThunk(
  '/getSurveyHeaderDetails',
  async (typeId) => {
    const response = await axios.get(`/GetSurveyHeaderDetails/${typeId}/${SessionUser.TenantId}`);
    return response.data;
  }
);

export const setCatalogItem = createAsyncThunk(
  '/SetCatalogItem',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetCatalogItem',
      data
    );
    return response.data;
  }
);

export const setSurveyQuestionItem = createAsyncThunk(
  '/SetSurveyQuestionItem',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetSurveyQuestionItem',
      data
    );
    return response.data;
  }
);

export const setSurveyHeaderItem = createAsyncThunk(
  '/SetSurveyHeaderItem',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetSurveyHeaderItem',
      data
    );
    return response.data;
  }
);

export const getTenantList = createAsyncThunk('/getTenantList', async () => {
  const response = await axiosHeadOffice.get('/Technician/GetTenantList');
  return response.data;
});


const surveyQuestionAnswerSlice = createSlice({
  name: 'surveyQuestionAnswer',
  initialState: {
    selectedQuestionId: 0,
    selectedAnswerId: 0,
    selectedHeaderId: 0,
    loading: false,
    error: '',
    Answers: [],
    Questions: [],
    Headers: [],
    AnswerDescriptions: [], 
    QuestionDescriptions: [],
    HeaderDescriptions: []
  },
  reducers: {
    changeselectedQuestionId(state, action) {
      state.selectedQuestionId = action.payload;
    },
    changeselectedAnswerId(state, action) {
      state.selectedAnswerId = action.payload;
    },
    changeselectedHeaderId(state, action) {
      state.selectedHeaderId = action.payload;
    },
    resetAnswerDescriptions(state) {
      state.AnswerDescriptions = [];
    },
    resetQuestionDescriptions(state) {
      state.QuestionDescriptions = [];
    },
    resetHeaderDescriptions(state) {
      state.HeaderDescriptions = [];
    },
  },
  extraReducers: {
    [getSurveyAnswers.pending]: state => {
      state.loading = true;
    },
    [getSurveyAnswers.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSurveyAnswers.fulfilled]: (state, action) => {
      state.Answers = action.payload;
      state.loading = false;
    },
    [getSurveyQuestions.pending]: state => {
        state.loading = true;
    },
    [getSurveyQuestions.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
    },
    [getSurveyQuestions.fulfilled]: (state, action) => {
        state.Questions = action.payload;
        state.loading = false;
    },
    [getSurveyHeaders.pending]: state => {
      state.loading = true;
    },
    [getSurveyHeaders.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSurveyHeaders.fulfilled]: (state, action) => {
      state.Headers = action.payload;
      state.loading = false;
    },
    [getSurveyQuestionDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSurveyQuestionDetails.fulfilled]: (state, action) => {
      state.QuestionDescriptions = action.payload;
      state.loading = false;
    },
    [getSurveyQuestionDetails.pending]: state => {
      state.loading = true;
    },
    [getSurveyAnswerDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSurveyAnswerDetails.fulfilled]: (state, action) => {
      state.AnswerDescriptions = action.payload;
      state.loading = false;
    },
    [getSurveyAnswerDetails.pending]: state => {
      state.loading = true;
    },
    [getSurveyHeaderDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSurveyHeaderDetails.fulfilled]: (state, action) => {
      state.HeaderDescriptions = action.payload;
      state.loading = false;
    },
    [getSurveyHeaderDetails.pending]: state => {
      state.loading = true;
    },
    [setCatalogItem.pending]: (state) => {
      state.loading = true;
    },
    [setCatalogItem.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setCatalogItem.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [setSurveyQuestionItem.pending]: (state) => {
      state.loading = true;
    },
    [setSurveyQuestionItem.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setSurveyQuestionItem.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [setSurveyHeaderItem.pending]: (state) => {
      state.loading = true;
    },
    [setSurveyHeaderItem.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setSurveyHeaderItem.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [getTenantList.pending]: (state) => {
      state.loading = true;
    },
    [getTenantList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTenantList.fulfilled]: (state, action) => {
      state.Tenants = action.payload;
      state.loading = false;
    }
  }
});

export const surveyQuestionAnswerActions = surveyQuestionAnswerSlice.actions;

export default surveyQuestionAnswerSlice;
